import * as React from "react";
import { ELoginScreenState, ELoginPopupState } from "./loginConstants";
import LoginIdScreen from "../../../components/login/loginScreen/loginIdScreen";
import ee from "../../../components/utils/eventEmitter";
import {
  AGetValidateUserId,
  ATotpLogin,
  A2FaLogin,
  AValidatePassword,
  ACommAccOpenPre,
} from "../../../services/login/loginApiService";
import PasswordScreen from "../../../components/login/loginScreen/passwordScreen";
import YobScreen from "../../../components/login/loginScreen/yobScreen";
import LoginService, {
  getPreLoginData,
  setPreLoginData,
  getUserID,
  setAccData,
  getAccData,
  parseQuery,
  logout,
  saveDataInLocalStorage,
  isLoggedIn,
} from "../../../services/login/loginService";
import urlConfig, { config } from "../../../config/domain";
import LoginStatusScreen from "../../../components/login/loginScreen/loginStatusScreen";
import LeadFormScreen from "../../../components/login/loginScreen/leadFormScreen";
import { ILeadFormFields } from "../../../components/login/forms/leadForm";
import { ClevertapService } from "../../../services/clevertapService";
import DeviceContext from "../../../services/indentifyDevice";

import { RouteChildrenProps } from "react-router-dom";
import LoginLoaderScreen from "../../../components/login/loginScreen/loginLoaderScreen";
import { MyAuthContext } from "../../../Context/AuthContext";
import { accRedircet } from "../../../services/genralServise";
import LoginWithApi from "../../../components/login/loginScreen/loginWithApi";
import YobWithAPi from "../../../components/login/loginScreen/yobWithApi";
import PasswordWithApi from "../../../components/login/loginScreen/passwordWithApi";
import OtpScreen from "../../../components/login/loginScreen/otpScreen";
import { RoutesUrl } from "../../Routes/constents";
import OtpWithAPi from "../../../components/login/loginScreen/otpWithApi";
import EtotpScreen from "../../../components/login/loginScreen/etotpScreen";
import EtotpWithApi from "../../../components/login/loginScreen/etotpWithApi";
import { ITotpLoginProps } from "../../../components/login/forms/etotpPasswordForm";
import { addTolocalStorage } from "../../Constants/commenFeatures";

export interface ILoginCtrlProps {}

export interface ILoginCtrlState {
  screenState: ELoginScreenState;
  popupState?: ELoginPopupState; // if undefined then popup is closed otherwise open in corresponding state
  disableForm: boolean;
  accTypes?: Array<any>;
  totpSetting?: ITotpLoginProps;
  errorMsg?: string;
  popupMessage?: string;
  appKeyDetails?:string;
  // myAuthContext?: any;
}

class LoginCtrl extends React.Component<
  ILoginCtrlProps & RouteChildrenProps,
  ILoginCtrlState
> {
  // login starts with LOGIN_ID screen
  state: ILoginCtrlState = {
    screenState: ELoginScreenState.LOGIN_ID,
    disableForm: false,
  };
  clevertapService = new ClevertapService();
  static contextType = MyAuthContext;

  componentDidMount() {
    // this.setState({myAuthContext:this.context})
    // console.log("this.contextType", isAuthContext)

    ee.on("changeLoginScreen", this.changeScreenState);
    ee.on("logout", () => this.postLogout());

    // If there is a query string in url, then read the values and store in Login Service
    if (window.location.search) {
      const queryString = parseQuery(window.location.search);
      if (queryString.api_key) {
        // PYTHON LIBRARY
        logout();
        // LoginService.hideCross = true;
      } else {
        accRedircet(config.root + "/login");
      }
    }
  }

  postLogout() {
    const queryString = parseQuery(window.location.search);
    sessionStorage.setItem("source", queryString.api_key);
    this.afterHandleQueryString();
  }

  afterHandleQueryString = async () => {
    // if user is logged in then redirect
    // if popupName is present then show popup
    // otherwise continue with normal login flow
    if (isLoggedIn() && !LoginService.popupName) {
      this.onClose();
      return;
    } else if (window.location.search) {
      const queryString = parseQuery(window.location.search);
      if (queryString.api_key) {
        this.changeScreenState(ELoginScreenState.LOGIN_WITH_API_KEY);
      }
    } else {
      this.openLogin();
    }
  };

  openLogin = () => {
    this.changeScreenState(ELoginScreenState.LOGIN_ID);
  };

  // optState is optional state that needs to be set along with screenState
  changeScreenState = (
    screenState: ELoginScreenState,
    optState?: { [key in keyof ILoginCtrlState]?: any }
  ) => {
    // if anything needs to be done specifically for a screen then only write the case
    switch (screenState) {
      case ELoginScreenState.LOGIN_ID:
        const userID = getUserID();
        setPreLoginData({ userID });

        if (userID) {
          this.getValidateUserId(userID);
        } else {
          this.setFocus("userID");
        }
        break;

      case ELoginScreenState.PASSWORD:
        this.setFocus("password");
        break;

      case ELoginScreenState.YOB:
        this.setFocus("yob-0");
        break;
      case ELoginScreenState.OTP:
        this.setFocus("otp");
        break;
    }

    // setstate is common for all screens
    this.setState({
      screenState,
      disableForm: false,
      errorMsg: undefined,
      ...optState,
    });
  };

  changePopupState = (popupState?: ELoginPopupState, optState?: any) => {
    this.setState({ popupState, ...optState });
  };

  //Set Focus
  setFocus = (id: string) => {
    setTimeout(function () {
      (document as Document).getElementById(id)?.focus();
    }, 150);
  };

  // this function is called after clicking on edit userid button on password screen
  showUserIdScreen = () => {
    this.onTimerClose();
    this.setState({
      disableForm: false,
      errorMsg: undefined,
    });
  };

  switchLoginFlow = (flow: string) => {
    this.setState({
      disableForm: false,
      errorMsg: undefined,
    });
    if (flow === "OTP") {
      this.changeScreenState(ELoginScreenState.PASSWORD);
    } else if (flow === "ETOTP"){
      this.changeScreenState(ELoginScreenState.ETOTP);
    }
  };

  switchApiKeyLoginFlow = (flow: string) => {
    this.setState({
      disableForm: false,
      errorMsg: undefined,
    });
    if (flow === "OTP") {
      this.changeScreenState(ELoginScreenState.PASSWORD_WITH_API_KEY);
    } else if (flow === "ETOTP"){
      this.changeScreenState(ELoginScreenState.ETOTP_WITH_API_KEY);
    }
  };

  // this function is called to remove error msg
  removeError = () => {
    this.setState({ errorMsg: undefined, disableForm: false });
  };

  // Called when user clicks on preceed on userid screen
  // used to get security image list
  getValidateUserId = (userID: string) => {
    this.setState({ disableForm: true });
    setPreLoginData({ userID: userID.toUpperCase() });
    if (window.location.search) {
      const queryString = parseQuery(window.location.search);
      if (queryString.api_key) {
        AGetValidateUserId(this.getValidateUserIdRes, userID.toUpperCase(), true);
      }
    } else {
      AGetValidateUserId(this.getValidateUserIdRes, userID.toUpperCase(), false);
    }
  };

  // response of security image list
  getValidateUserIdRes = (res: any) => {
    if (res.data && res.data.sts && res.data.loginFlow) {
      addTolocalStorage("LoginFlow", res.data.loginFlow);
      if (window.location.search) {
        const queryString = parseQuery(window.location.search);
        if (queryString.api_key) {
          if(res.data.loginFlow == "ETOTP"||res.data.loginFlow == "BOTH"){
            this.changeScreenState(ELoginScreenState.ETOTP_WITH_API_KEY, {
              accTypes: res.data.accTypes,
              appKeyDetails: res.data,
              totpSetting: res.data.totpSetting
            });
          } else if(res.data.loginFlow == "TOTP"||res.data.loginFlow == "OTP"){
            this.changeScreenState(ELoginScreenState.PASSWORD_WITH_API_KEY, {
              accTypes: res.data.accTypes,
              appKeyDetails: res.data,
            });
          }
        }
      } else {
        if(res.data.loginFlow == "ETOTP"||res.data.loginFlow == "BOTH"){
          this.changeScreenState(ELoginScreenState.ETOTP, {
            accTypes: res.data.accTypes,
            totpSetting: res.data.totpSetting
          });
        } else if(res.data.loginFlow == "TOTP"||res.data.loginFlow == "OTP"){
          this.changeScreenState(ELoginScreenState.PASSWORD, {
            accTypes: res.data.accTypes,
          });
        }
      }
    } else {
      this.setState({ errorMsg: res.error.errMsg, disableForm: false });
    }
  };

  // called first when user clicks on proceed on password screen
  // used to validate the combination of userid and password
  validatePassword = (pwd: string, accTyp: string) => {
    this.setState({ disableForm: true });
    setPreLoginData({ accTyp, pwd });
    let userid = getPreLoginData("userID") || parseQuery(window.location.search).api_key;
    AValidatePassword(this.validatePasswordRes, userid, accTyp, pwd);
  };

  // response of 2faquestions
  validatePasswordRes = (res: any) => {
    if (res.data && res.data.sts == true) {
      if (window.location.search) {
        const queryString = parseQuery(window.location.search);
        if (queryString.api_key) {
          // PYTHON LIBRARY
          if (res.data?.loginFlow === "OTP") {
            this.changeScreenState(ELoginScreenState.OTP_WITH_API_KEY);
          } else {
            this.changeScreenState(ELoginScreenState.YOB_WITH_API_KEY);
          }
        }
      } else {
        if (res.data?.loginFlow === "OTP") {
          this.changeScreenState(ELoginScreenState.OTP);
        } else {
          this.changeScreenState(ELoginScreenState.YOB);
        }
      }
    } else {
      this.setState({ errorMsg: res.error.errMsg, disableForm: false });
    }
  };

  // used to verify yob
  verifyAnswers = (ans: string) => {
    if (this.state.screenState == ELoginScreenState.YOB) {
      this.setState({ disableForm: true });
    }
    // pass vendor details if vendor is availables

    A2FaLogin(
      this.verifyAnswersRes,
      getPreLoginData("userID"),
      getPreLoginData("accTyp"),
      getPreLoginData("pwd"),
      ans
    );
  };

  quickLogin = (pwd: string, accTyp: string, totp: string, loginFlow: string) => {
    this.setState({ disableForm: true });
    setPreLoginData({ accTyp, pwd });
    let userid = getPreLoginData("userID") || parseQuery(window.location.search).api_key;
    ATotpLogin(this.verifyAnswersRes , userid, accTyp, pwd, totp, loginFlow);
  };

  verifyAnswersRes = (res: any, meta: Response) => {
    try {
      if (res) {
        if (res.data && res.data.sts !== "INVALID_ANSWERS") {
          // set all data in dataservice
          setAccData(res.data);

          // cleverTapRegistration();

          if (meta.headers.get("appidkey")) {
            urlConfig.appidkey = meta.headers.get("appidkey") as string;
          }
          LoginService.authorization = meta.headers.get(
            "authorization"
          ) as string;
          LoginService.jwtToken = (meta.headers.get("ewjwt") as string).split(
            " "
          )[1];
          saveDataInLocalStorage();
          this.onClose();
        } else {
          if (res.error && res.error.errMsg.includes("Account Blocked")) {
            this.setState({
              errorMsg: res.error.errMsg,
              disableForm: true,
            });
          } else {
            this.setState({
              errorMsg:
                (res.data && res.data.sts) || (res.error && res.error.errMsg),
              disableForm: false,
            });
          }
        }

        var data = {
          LoginType: "Traditional",
          EventName: "Login Successful",
          Platform: DeviceContext().isMobile
            ? "Website_Mobile"
            : "Website_Desktop",
          InitiationScreen: "Login",
          InitiationElement: "Continue",
        };

        this.clevertapService.pushEvent(data);
      }
    } catch (error) {
      console.log("Error inside the catch block", error);
    }
  };

  submitLeadForm = (values: ILeadFormFields) => {
    this.setState({ disableForm: true });
    ACommAccOpenPre(this.submitLeadFormRes, values);
  };

  submitLeadFormRes = (res: any) => {
    if (res.data) {
      this.changePopupState(ELoginPopupState.OPEN_ACC_SUCC, {
        popupMessage: res.data.msg,
      });
    } else {
      this.setState({ errorMsg: res.error.errMsg, disableForm: false });
    }
  };

  onClose = () => {
    const accData = getAccData();
    const { url: _, ...accDataTemp } = accData;
    localStorage.setItem("acc_data", JSON.stringify(accDataTemp));
    this.redirect(accData);

    // accData.url + "?request_id=" + accData.reqId
  };
  onTimerClose = () => {
    if (window.location.search) {
      const queryString = parseQuery(window.location.search);
      if (queryString.api_key) {
        this.changeScreenState(ELoginScreenState.LOGIN_WITH_API_KEY);
      }
    } else {
      this.changeScreenState(ELoginScreenState.LOGIN_ID);
    }
  };

  redirect(accData: any) {
    const isApikey = window.location.href.includes("api_key");
    if (isApikey) {
      let isAccDataUrl = accData.url || "http://127.0.0.1";
      if (isAccDataUrl.includes("?")) {
        let url = isAccDataUrl + "&request_id=" + accData.reqId;
        return (window.location.href = url);
      } else {
        let url = isAccDataUrl + "?request_id=" + accData.reqId;
        return (window.location.href = url);
      }
    }

    if (accData.mndtryLoginCnsts && accData.mndtryLoginCnsts.length > 0) {
      let isTncAccepted = accData.mndtryLoginCnsts.filter((getCen: any) => {
        return getCen.name === "APIConsent";
      });
      if (isTncAccepted.length > 0) {
        this.context.isAuthFunction(true, false);
        localStorage.setItem("tncAccepted", "false");
        // this.props.history.push("terms-conditions");
        accRedircet(config.root + RoutesUrl.TermsAndConditions);
      }
    } else {
      localStorage.setItem("tncAccepted", "true");
      this.context.isAuthFunction(true, true);
      accRedircet(config.root + RoutesUrl.MyApps);
    }

    // if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
    // 	// If url is absolute
    // 	window.location.href = url;
    // } else {
    // if url is relative
    // }
  }

  prevScreen = () => {
    this.props.history.push("/");
  };

  closePopup = () => {
    this.changePopupState(undefined, {
      popupMessage: undefined,
      screenState: ELoginScreenState.LOGIN_ID,
    });
  };

  getScreen() {
    switch (this.state.screenState) {
      case ELoginScreenState.LOADING:
        return <LoginLoaderScreen />;

      case ELoginScreenState.LOGIN_ID:
        return (
          <LoginIdScreen
            disableForm={this.state.disableForm}
            onSubmit={this.getValidateUserId}
            userName={getPreLoginData("userID")}
            errorMsg={this.state.errorMsg}
            onRemoveError={this.removeError}
            onClose={LoginService.hideCross ? undefined : this.prevScreen}
          />
        );

      case ELoginScreenState.PASSWORD:
        return (
          <PasswordScreen
            loginId={getPreLoginData("userID")}
            accTypesObject={this.state.accTypes}
            disableForm={this.state.disableForm}
            errorMsg={this.state.errorMsg}
            onEditLoginId={this.showUserIdScreen}
            onSubmit={this.validatePassword}
            onRemoveError={this.removeError}
            onClose={LoginService.hideCross ? undefined : this.prevScreen}
          />
        );
      case ELoginScreenState.ETOTP:
        return (
          <EtotpScreen
            loginId={getPreLoginData("userID")}
            securityImgObj={this.state.accTypes}
            disableForm={this.state.disableForm}
            totpSetting={this.state.totpSetting as ITotpLoginProps}
            errorMsg={this.state.errorMsg}
            onEditLoginId={this.showUserIdScreen}
            onSubmit={this.quickLogin}
            onRemoveError={this.removeError}
            onSwitchLoginFlow={this.switchLoginFlow}
            onClose={LoginService.hideCross ? undefined : this.prevScreen}
          />
        );
      case ELoginScreenState.YOB:
        return (
          <YobScreen
            disableForm={this.state.disableForm}
            errorMsg={this.state.errorMsg}
            onSubmit={this.verifyAnswers}
            onRemoveError={this.removeError}
            onClose={LoginService.hideCross ? undefined : this.prevScreen}
          />
        );
      case ELoginScreenState.OTP:
        return (
          <OtpScreen
            disableForm={this.state.disableForm}
            redirect={
              this.state.disableForm ? RoutesUrl.ClientUnblockAccount : ""
            }
            redirectText={this.state.disableForm ? "Unblock account" : ""}
            errorMsg={this.state.errorMsg}
            onSubmit={this.verifyAnswers}
            onRemoveError={this.removeError}
            onClose={LoginService.hideCross ? undefined : this.prevScreen}
            onTimerClose={this.onTimerClose}
            onSwitchLoginFlow={this.switchLoginFlow}
          />
        );
      case ELoginScreenState.LOGIN_WITH_API_KEY:
        return (
          <LoginWithApi
            disableForm={this.state.disableForm}
            onSubmit={this.getValidateUserId}
            userName={getPreLoginData("userID")}
            errorMsg={this.state.errorMsg}
            onRemoveError={this.removeError}
            onClose={LoginService.hideCross ? undefined : this.prevScreen}
          />
        );
      case ELoginScreenState.PASSWORD_WITH_API_KEY:
        return (
          <PasswordWithApi
            loginId={getPreLoginData("userID")}
            accTypesObject={this.state.accTypes}
            securityImgObj={this.state.appKeyDetails}
            disableForm={this.state.disableForm}
            errorMsg={this.state.errorMsg}
            onEditLoginId={this.showUserIdScreen}
            onSubmit={this.validatePassword}
            onRemoveError={this.removeError}
            onClose={LoginService.hideCross ? undefined : this.prevScreen}
          />
        );
        case ELoginScreenState.ETOTP_WITH_API_KEY:
          return (
            <EtotpWithApi
              loginId={getPreLoginData("userID")}
              securityImgObj={this.state.appKeyDetails}
              disableForm={this.state.disableForm}
              totpSetting={this.state.totpSetting as ITotpLoginProps}
              errorMsg={this.state.errorMsg}
              onEditLoginId={this.showUserIdScreen}
              onSubmit={this.quickLogin}
              onRemoveError={this.removeError}
              onSwitchLoginFlow={this.switchApiKeyLoginFlow}
              onClose={LoginService.hideCross ? undefined : this.prevScreen}
            />
          );
      case ELoginScreenState.YOB_WITH_API_KEY:
        return (
          <YobWithAPi
            disableForm={this.state.disableForm}
            errorMsg={this.state.errorMsg}
            onSubmit={this.verifyAnswers}
            securityImgObj={this.state.appKeyDetails}
            onRemoveError={this.removeError}
            onClose={LoginService.hideCross ? undefined : this.prevScreen}
          />
        );
      case ELoginScreenState.OTP_WITH_API_KEY:
        return (
          <OtpWithAPi
            disableForm={this.state.disableForm}
            redirect={
              this.state.disableForm ? RoutesUrl.ClientUnblockAccount : ""
            }
            redirectText={this.state.disableForm ? "Unblock account" : ""}
            errorMsg={this.state.errorMsg}
            onSubmit={this.verifyAnswers}
            securityImgObj={this.state.appKeyDetails}
            onRemoveError={this.removeError}
            onSwitchLoginFlow={this.switchApiKeyLoginFlow}
            onClose={LoginService.hideCross ? undefined : this.prevScreen}
            onTimerClose={this.onTimerClose}
          />
        );

      case ELoginScreenState.LEAD_FORM:
        return (
          <LeadFormScreen
            errorMsg={this.state.errorMsg}
            onRemoveError={this.removeError}
            onSubmit={this.submitLeadForm}
            disableForm={this.state.disableForm}
            onClose={
              LoginService.hideCross
                ? undefined
                : () => this.changeScreenState(ELoginScreenState.LOGIN_ID)
            }
          />
        );

      default:
        return <></>;
    }
  }

  getPopup() {
    switch (this.state.popupState) {
      case ELoginPopupState.LOGINID_SENT:
        return (
          <LoginStatusScreen
            popupState={this.state.popupState}
            message={this.state.popupMessage}
            onLinkClick={
              LoginService.hideCross
                ? undefined
                : () =>
                    this.changePopupState(undefined, {
                      popupMessage: undefined,
                    })
            }
            onClose={this.closePopup}
          />
        );

      case ELoginPopupState.OPEN_ACC_SUCC:
        return (
          <LoginStatusScreen
            popupState={this.state.popupState}
            onLinkClick={this.onClose}
            message={this.state.popupMessage}
            onClose={this.closePopup}
          />
        );

      case ELoginPopupState.EMAIL_SENT:
        return (
          <LoginStatusScreen
            popupState={this.state.popupState}
            onClose={this.closePopup}
          />
        );

      default:
        return undefined;
    }
  }

  render() {
    return (
      <>
        {this.getScreen()} {this.getPopup()}
      </>
    );
  }
}

export default LoginCtrl;
